const WorkflowProcessIds = {
  NewRegistration: 1,
};

export default WorkflowProcessIds;
